var _style, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCengagelogofull(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    style: {
      enableBackground: "new 0 0 265 61"
    },
    viewBox: "0 0 61 61",
    x: "0px",
    xmlSpace: "preserve",
    y: "0px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000145777782130380958690000008982705514359901069_);fill:#292F7C;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    height: 108.83,
    id: "SVGID_1_",
    width: 324.31,
    x: -29.58,
    y: -23.91
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000042710670575473299220000014712045830203263367_"
  }, /*#__PURE__*/React.createElement("use", {
    style: {
      overflow: "visible"
    },
    xlinkHref: "#SVGID_1_"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M39.51,18.36     l-0.36-1.72l-0.21-0.99L37.5,8.69c0,0,0,0,0,0l-0.36-1.72c-0.14-0.67-0.81-1.18-1.5-1.15l-6.55,0.31c-0.69,0.03-1.14,0.6-1,1.27     l0.77,3.72l2.01,9.67c0.14,0.67,0.79,1.06,1.44,0.87l6.25-1.76C39.22,19.72,39.65,19.02,39.51,18.36",
    style: {
      clipPath: "url(#SVGID_00000042710670575473299220000014712045830203263367_)",
      fill: "#292F7C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.98,48.01     l1.66,0.58l0.96,0.34l6.7,2.36c0,0,0,0,0,0l1.66,0.58c0.64,0.23,1.43-0.08,1.76-0.69l3.12-5.77c0.33-0.6,0.07-1.28-0.57-1.51     l-3.58-1.26l-9.31-3.28c-0.64-0.23-1.31,0.13-1.49,0.78l-1.73,6.26C28.97,47.07,29.34,47.79,29.98,48.01",
    style: {
      clipPath: "url(#SVGID_00000042710670575473299220000014712045830203263367_)",
      fill: "#292F7C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.31,13.4     l-1.66-0.56l-0.96-0.33l-6.73-2.29c0,0,0,0,0,0L11.3,9.66c-0.64-0.22-1.43,0.1-1.75,0.71l-3.06,5.81     c-0.32,0.61-0.06,1.28,0.59,1.5l3.6,1.22l9.35,3.18c0.64,0.22,1.31-0.14,1.48-0.8L23.16,15C23.34,14.34,22.95,13.62,22.31,13.4",
    style: {
      clipPath: "url(#SVGID_00000042710670575473299220000014712045830203263367_)",
      fill: "#292F7C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.78,42.64     l0.35,1.72l0.2,0.99l1.43,6.96c0,0,0,0,0,0l0.35,1.72c0.14,0.67,0.81,1.18,1.5,1.15l6.55-0.3c0.69-0.03,1.14-0.6,1-1.27     l-0.77-3.72l-1.99-9.67c-0.14-0.67-0.79-1.06-1.44-0.88l-6.26,1.75C13.07,41.28,12.65,41.97,12.78,42.64",
    style: {
      clipPath: "url(#SVGID_00000042710670575473299220000014712045830203263367_)",
      fill: "#292F7C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.47,25.68     l-1.33,1.14l-0.77,0.66L1.97,32.1v0l-1.33,1.14C0.13,33.69,0,34.53,0.36,35.12L3.8,40.7c0.36,0.59,1.08,0.7,1.59,0.26l2.88-2.47     l7.49-6.43c0.52-0.44,0.55-1.2,0.07-1.68l-4.56-4.62C10.8,25.27,9.98,25.23,9.47,25.68",
    style: {
      clipPath: "url(#SVGID_00000042710670575473299220000014712045830203263367_)",
      fill: "#292F7C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.71,36.15     l1.33-1.14l0.77-0.66l5.39-4.63v0l1.33-1.14c0.52-0.44,0.64-1.28,0.28-1.87l-3.44-5.59c-0.36-0.59-1.08-0.7-1.59-0.26l-2.88,2.47     l-7.49,6.43c-0.52,0.44-0.55,1.2-0.07,1.68l4.56,4.62C41.38,36.56,42.19,36.59,42.71,36.15",
    style: {
      clipPath: "url(#SVGID_00000042710670575473299220000014712045830203263367_)",
      fill: "#292F7C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.8,35.44     l4.69,2.73c-2.54,4.93-7.13,7.91-13.23,7.91c-4.88,0-8.84-1.71-11.91-5.13c-3.08-3.42-4.59-7.62-4.59-12.65     c0-5.03,1.51-9.23,4.59-12.65c3.08-3.42,7.03-5.13,11.91-5.13c6.1,0,10.69,3.03,13.23,7.96l-4.69,2.73     c-1.66-3.71-4.49-5.57-8.54-5.57c-3.32,0-5.96,1.22-7.91,3.61c-1.95,2.39-2.93,5.42-2.93,9.03s0.98,6.64,2.93,9.03     c1.95,2.39,4.59,3.61,7.91,3.66C84.31,40.96,87.14,39.11,88.8,35.44",
    style: {
      clipPath: "url(#SVGID_00000042710670575473299220000014712045830203263367_)",
      fill: "#292F7C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.8,34.71h-19.92     c0.54,4.49,2.93,6.64,7.62,6.64c3.42,0,5.81-1.22,7.23-3.61l3.95,2.34c-2.1,3.56-6.3,6.01-11.18,6.01     c-3.95,0-7.08-1.17-9.37-3.56c-2.29-2.39-3.42-5.66-3.42-9.76c0-3.91,1.17-7.13,3.47-9.62c2.34-2.49,5.47-3.76,9.33-3.76     c3.66,0,6.59,1.17,8.79,3.56c2.2,2.34,3.37,5.47,3.52,9.33V34.71z M116.97,29.98c-0.63-3.71-3.56-6.01-7.47-6.01     c-3.76,0-6.64,2.15-7.47,6.01H116.97z",
    style: {
      clipPath: "url(#SVGID_00000042710670575473299220000014712045830203263367_)",
      fill: "#292F7C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.17,45.65h-5.32     V29.88c0-4.35-2.1-5.91-4.49-5.91c-5.37,0-8.06,3.66-8.06,11.03v10.64h-5.32V19.82h5.32l1.07,2.59c2.15-2,4.59-3.03,7.27-3.03     c6.35,0,9.52,3.37,9.52,10.15V45.65z",
    style: {
      clipPath: "url(#SVGID_00000042710670575473299220000014712045830203263367_)",
      fill: "#292F7C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.76,42.23     c0,8.74-4.74,12.65-12.35,12.65c-5.52,0-9.57-1.22-12.16-3.71l3.42-4c2.1,2,4.98,3.03,8.64,3.03c4.88,0,7.13-2.49,7.13-7.96     c-1.12,2.39-3.71,4.05-7.27,4.05c-3.61,0-6.49-1.32-8.69-3.95c-2.15-2.69-3.22-5.86-3.22-9.57c0-3.56,1.12-6.69,3.37-9.37     c2.25-2.69,5.22-4,8.93-4c2.29,0,4.35,0.78,6.15,2.39l0.73-1.95h5.32V42.23z M172.87,39.01c1.32-1.71,1.95-3.76,1.95-6.25     c0-2.39-0.64-4.39-1.95-6.1c-1.32-1.71-3.08-2.54-5.32-2.54c-4.88,0-6.98,3.71-6.98,8.64c0,2.39,0.54,4.44,1.66,6.2     c1.12,1.71,2.93,2.59,5.32,2.59C169.8,41.55,171.55,40.72,172.87,39.01",
    style: {
      clipPath: "url(#SVGID_00000042710670575473299220000014712045830203263367_)",
      fill: "#292F7C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.46,45.65h-3.91     c-1.17,0-1.76-0.83-1.76-2.44c-1.95,1.95-3.56,2.88-7.08,2.88c-5.47,0-9.52-2.64-9.52-7.96c0.2-4.44,2-6.59,5.42-7.47     c2.39-0.73,4.1-0.83,7.18-0.98c2.59-0.1,3.86-0.93,3.86-2.49c0-1.76-2.05-3.37-4.98-3.37c-2.83,0-4.98,1.03-6.44,3.08l-3.47-3.03     c2.2-2.93,5.86-4.49,9.91-4.49c6.1,0,9.96,3.37,9.96,9.57v14.79c0,0.68,0.29,1.03,0.83,1.03V45.65z M199.43,39.84     c0.93-1.32,1.42-3.27,1.42-5.76v-1.46c-0.54,0.73-1.95,1.07-2.78,1.22c-0.39,0.05-1.02,0.05-1.9,0.1     c-0.83,0.05-1.32,0.05-1.37,0.05c-3.52,0.15-5.27,1.56-5.27,4.15c0,1.71,1.22,3.71,4.2,3.71     C196.6,41.84,198.5,41.16,199.43,39.84",
    style: {
      clipPath: "url(#SVGID_00000042710670575473299220000014712045830203263367_)",
      fill: "#292F7C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.93,42.23     c0,8.74-4.74,12.65-12.35,12.65c-5.52,0-9.57-1.22-12.16-3.71l3.42-4c2.1,2,4.98,3.03,8.64,3.03c4.88,0,7.13-2.49,7.13-7.96     c-1.12,2.39-3.71,4.05-7.27,4.05c-3.61,0-6.49-1.32-8.69-3.95c-2.15-2.69-3.22-5.86-3.22-9.57c0-3.56,1.12-6.69,3.37-9.37     c2.25-2.69,5.22-4,8.93-4c2.29,0,4.35,0.78,6.15,2.39l0.73-1.95h5.32V42.23z M228.04,39.01c1.32-1.71,1.95-3.76,1.95-6.25     c0-2.39-0.64-4.39-1.95-6.1c-1.32-1.71-3.08-2.54-5.32-2.54c-4.88,0-6.98,3.71-6.98,8.64c0,2.39,0.54,4.44,1.66,6.2     c1.12,1.71,2.93,2.59,5.32,2.59C224.97,41.55,226.72,40.72,228.04,39.01",
    style: {
      clipPath: "url(#SVGID_00000042710670575473299220000014712045830203263367_)",
      fill: "#292F7C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265,34.71h-19.92     c0.54,4.49,2.93,6.64,7.62,6.64c3.42,0,5.81-1.22,7.23-3.61l3.95,2.34c-2.1,3.56-6.3,6.01-11.18,6.01     c-3.95,0-7.08-1.17-9.37-3.56c-2.29-2.39-3.42-5.66-3.42-9.76c0-3.91,1.17-7.13,3.47-9.62c2.34-2.49,5.47-3.76,9.33-3.76     c3.66,0,6.59,1.17,8.79,3.56c2.2,2.34,3.37,5.47,3.52,9.33V34.71z M260.17,29.98c-0.63-3.71-3.56-6.01-7.47-6.01     c-3.76,0-6.64,2.15-7.47,6.01H260.17z",
    style: {
      clipPath: "url(#SVGID_00000042710670575473299220000014712045830203263367_)",
      fill: "#292F7C"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCengagelogofull);
export default __webpack_public_path__ + "static/media/cengagelogofull.fdaabf34ac07ce93b425cca0e43b048c.svg";
export { ForwardRef as ReactComponent };